import request from "../utils/request";

export default {
    me(params, data) {
        return request({url: '/me', method: 'get', params, data})
    },
    my(params, data) {
        // console.log('api - params',params)
        return request({url: '/me/my', method: 'get', params, data})
    },
    private(params, data) {
        return request({url: '/me/private1', method: 'get', params, data})
    },
    like(params, data) {
        return request({url: '/me/like', method: 'get', params, data})
    },
    collect(params, data) {
        return request({url: '/me/collect', method: 'get', params, data})
    },
    recommended2(params, data) {
        return request({url: '/video/recommended', method: 'get', params, data})
    },
    recommended(params, data) {
        // return request({url: '/video/recommended', method: 'get', params, data})
        // return request({url: 'plus/view2.php?aid=102', method: 'get', params, data})
    },
    post(params, data) {
        return request({url: '/aweme/post', method: 'get', params, data})
    },
    video_cate(params, data) {
        return request({url: '/plus/list_cate.php', method: 'get', params, data})
    },
    video_list(params, data) {
        return request({url: '/plus/list_video.php', method: 'get', params, data})
    },
    video(params, data) {
        return request({url: '/plus/view_video.php', method: 'get', params, data})
    },
    live(params, data) {
        return request({url: '/plus/view_live.php', method: 'get', params, data})
    },
    pay(params, data) {
        return request({url: '/plus/pay/experience.php', method: 'get', params, data})
    },
    getOpenId(params, data) {
        return request({url: '/plus/pay/get_openid.php', method: 'get', params, data})
    },
    view_pay(params, data) {
        return request({url: '/plus/view_pay.php', method: 'get', params, data})
    },
    share(data) {
        return request({url: '/share11.php', method: 'post', data})
    }
}
